export default __webpack_public_path__ + "static/vs-no-ff79735e22ba62cdd81d74dc4941f13c.mp4";